module.exports = __webpack_public_path__ + "static/media/Lesson-2-12-El-Espiritu-Santo-Nos-Pertenece.565e97c1.pdf";